import { ValidationArguments } from 'class-validator';
import { MessageCodes } from '../../../resources/message-codes';
import { BaseValidation } from './base-validation';
import { ValidationErrorCodes } from '../../../resources/validation-error-codes';
import { CodeValueMessageArg } from '../../../resources/code-value-message-arg';
import { MessageResourceManager } from '../../../resources/message-resource-manager';

export class EmailValidator {

  errorMessage: string;
  messageCode: string;

  errorMessageKey = MessageCodes.PropertyEmailNotValid;
  errorMessageTagNomeCampoKey = MessageCodes.PropertyEmailNotValid_TAG_NomeCampo;

  #displayName: string;

  /**
   * Costruttore del validatore di email, accetta come parametro il display name da utilizzare nei messaggi di errore
   * @param displayName display name da utilizzare nei messaggi di errore, se non specificato viene utilizzata una stringa vuota
   */
  constructor(displayName: string = '') {
    this.#displayName = displayName;
  }

  validate(value: any): boolean {
    this.errorMessage = this.#getMessageWithTag(
      this.#displayName,
      this.errorMessageTagNomeCampoKey,
      this.errorMessageKey
    );
    this.messageCode = ValidationErrorCodes.EmailNotValid;

    const isValid = this.#isEmail(value);
    return isValid;
  }

  #isEmail(value: string): boolean {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
  }

  #getMessageWithTag(displayName: string, tag: string, messageCode: string): string {
    return this.#getMessageWithCodeValues(messageCode, [{ code: tag, value: displayName }]);
  }

  #getMessageWithCodeValues(baseMessage: string, tags: { code: string, value: string; }[]): string {
    const arr = new Array<CodeValueMessageArg>();
    for (const tag of tags) {
      const arg = new CodeValueMessageArg();
      arg.code = tag.code;
      arg.value = tag.value;
      arr.push(arg);
    }
    return MessageResourceManager.Current.getMessageWithArgs(baseMessage, arr);
  }
}
export class EmailValidation extends BaseValidation<string> {

  constructor() {
    super(MessageCodes.PropertyEmailNotValid);
  }

  validateImplementation(value: string, args: ValidationArguments): boolean {
    const validator = new EmailValidator(this.getDisplayName(args));
    if (!validator.validate(value) && value?.length > 0) {
      this.errorMessage = validator.errorMessage;
      this.messageCode = validator.messageCode;
      return false;
    }
    return true;
  }
}
